import HttpUtil, { PageResponse, ResultResponse } from '@/api'

// 系统-职务
export type PageDictionaryResponse = {
    // 职务 ID
    id: string
    // 名称
    name: string
    // 编码
    code: string
    // 备注
    remark: string
}

// 系统-职务
export type AddDictionaryRequest = {
    // 名称
    name?: string
    // 是否启用：0=否，1=是
    isEnable?: number
    // 键
    key?: string
    // 值
    value?: string
    // 排序
    sort?: number
    // 备注
    remark?: string
    // 分类 ID
    categoryId?: string
}

// 系统-职务
export type UpdateDictionaryRequest = {
    // 职务 ID
    id?: string
    // 名称
    name?: string
    // 是否启用：0=否，1=是
    isEnable?: number
    // 值
    value?: string
    // 排序
    sort?: number
    // 备注
    remark?: string
}

export type PageDictionaryRequest = {
    // 当前页
    pageNumber?: number
    // 每页大小
    pageSize?: number
    // 名称
    name?: string
    // 编码
    code?: string
}

// 系统-职务
export type GetDictionaryRequest = {
    // 职务 ID
    id: string
}

export type DeleteDictionaryRequest = {
    // 职务 ID
    id?: string
}

export type ListDictionaryRequest = {
    // 字典分类编码/字典键数组
    codeList: Code[]
}

export enum DictionaryCodeTypeEnum {
    // 字典分类编码
    CATEGORY_CODE = 1,
    // 字典键
    KEY = 2,
}

export type Code = {
    // 类型：1=字典分类编码，2=字典键
    type: number
    // 字典分类编码/字典键
    code: string
}

export type ListDictionaryResponse = {
    // 字典 ID
    id: string
    // 是否启用：0=否，1=是
    isEnable: number
    // 名称
    name: string
    // 键
    key: string
    // 值
    value: string
    // 排序
    sort: number
    // 分类编码
    categoryCode: string
    // 备注
    remark: string
    // 分类 ID
    categoryId: string
}

// 系统-字典
export type GetDictionaryResponse = {
    // 字典 ID
    id: string
    // 是否启用：0=否，1=是
    isEnable: number
    // 名称
    name: string
    // 编码
    key: string
    // 值
    value: string
    // 排序
    sort: number
    // 备注
    remark: string
    // 分类 ID
    categoryId: string
}

export type MoveDictionaryRequest = {
    // 源 ID
    sourceId: string
    // 目标 ID
    targetId: string
}

export class Dictionary {
    static async move(request: MoveDictionaryRequest) {
        return await HttpUtil.post<ResultResponse>('/system/dictionary/move', request)
    }

    static async add(request: AddDictionaryRequest) {
        return await HttpUtil.post<ResultResponse>('/system/dictionary/add', request)
    }

    static async get(request: GetDictionaryRequest) {
        return await HttpUtil.post<ResultResponse<GetDictionaryResponse>>('/system/dictionary/get', request)
    }

    static async update(request: UpdateDictionaryRequest) {
        return await HttpUtil.post<ResultResponse>('/system/dictionary/update', request)
    }

    static async remove(request: DeleteDictionaryRequest) {
        return await HttpUtil.post<ResultResponse>('/system/dictionary/delete', request)
    }

    static async list(request: ListDictionaryRequest) {
        return await HttpUtil.post<ResultResponse<ListDictionaryResponse[]>>('/system/dictionary/list', request)
    }

    static async page(request: PageDictionaryRequest) {
        return await HttpUtil.post<ResultResponse<PageResponse<PageDictionaryResponse>>>(
            '/system/dictionary/page',
            request,
        )
    }
}
